import { axios } from '../request'

export default (app) => {
  return {
    namespaced: true,
    state: {
      status: null,
      data: {},
    },
    mutations: {
      setData(state, data) {
        state.data = data
      },
      loading(state) {
        Object.assign(state, { loaded: false, loading: true })
      },
      loaded(state) {
        Object.assign(state, { loaded: true, loading: false })
      },
      notLoaded(state) {
        Object.assign(state, { loaded: false, loading: false })
      },
      setLastStatus(state, s) {
        state.status = s
      },
    },
    actions: {
      read(context, data) {
        return new Promise((resolve, reject) => {
          const url = 'payment_advice'
          context.commit('loading')
          if (typeof data.memberId === 'undefined' || typeof data.type === 'undefined') {
            context.commit('setData', { data: {} })
            reject(new Error('Not Enough Data'))
            return
          }
          if (data.type === 'quota' && typeof data.year === 'undefined') {
            reject(new Error('Not Enough Data'))
            return
          }
          let params = `?memberID=${data.memberId}&type=${data.type}`
          if (data.type === 'quota') {
            params += `&year=${data.year}`
          }
          axios
            .get(`${url}${params}`)
            .then((res) => {
              context.commit('setData', res.data.data)
              context.commit('loaded')
              context.commit('setLastStatus', res.status)
              resolve()
            })
            .catch((err) => {
              context.commit('setData', { data: {} })
              if (err.response) {
                context.commit('setLastStatus', err.response.status)
                if (err.response.status === 404) {
                  context.commit('loaded')
                }
              } else {
                context.commit('notLoaded')
              }
              reject(new Error('Could not read item'))
            })
        })
      },
    },
  }
}
